import { Colors } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
let currentSeasonSelected = 0;

export default class Button extends Lightning.Component {
  static _template() {
    return {
      ButtonText: {},
      Border: {
        collision: true,
        texture: Lightning.Tools.getRoundRect(514, 60, 13, 3, Colors('#000000').get(), false),
      },
    };
  }

  set data(val) {
    return (this._data = val);
  }

  set index(val) {
    this._index = val;
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Season');
    this.fireAncestors('$setSeasonIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _focus() {
    this._ButtonText.patch({
      color: Colors('#fafafa').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(514, 60, 13, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._ButtonText.patch({
      color: Colors('#B9B9B9').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(514, 60, 13, 3, Colors('#000000').get(), false),
    });
  }

  _firstEnable() {
    currentSeasonSelected = 0;
    this._ButtonText.patch({
      w: 235,
      h: 70,
      y: 10,
      color: Colors('#B9B9B9').get(),
      text: {
        text: this._data.series,
        textAlign: 'center',
        fontFace: 'OpenSans-Regular',
        fontSize: 32,
      },
    });
  }

  _handleEnter() {
    if (this._index === currentSeasonSelected) {
      return;
    }
    this.fireAncestors('$changeEpisodes', {
      seriesId: this._data.seriesId,
      seasonId: this._data.seasonId,
    });
    currentSeasonSelected = this._index;
  }

  get _ButtonText() {
    return this.tag('ButtonText');
  }

  get _Border() {
    return this.tag('Border');
  }
}
